export default {
  default: null,
  style: 2,
  listType: 'type-my-own',
  typeMyOwn: ''
};